import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import theme from '../styles/theme';

const DividingLine = ({ className, classes }) => (
  <hr className={cn(className, classes.line)} />
);

DividingLine.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
};

DividingLine.defaultProps = {
  className: undefined,
};

export default injectSheet({
  line: {
    marginTop: 0,
    borderColor: theme.colors.dividingLine,
  },
})(DividingLine);
